import { FC, ReactNode } from 'react';
import { Toaster } from 'sonner';

interface ToastProviderProps {
  children: ReactNode;
}

export const ToastProvider: FC<ToastProviderProps> = ({ children }) => (
  <>
    <Toaster richColors position="top-right" />
    {children}
  </>
);
